import { createContext } from "@pharaday/utils";

import type { EmptyStateRootProps } from "./Root";

export type EmptyStateRootContext = Pick<EmptyStateRootProps, "size">;

const [useEmptyStateRootContext, EmptyStateRootContextProvider] = createContext<EmptyStateRootContext>();

export { EmptyStateRootContextProvider, useEmptyStateRootContext };
